import { hipNewUrl } from '../../api';
import { UseFetchOptions } from './useFetch';

/**
 * This module can be used to centralize all fetch call metadata for useFetch hook
 * Note that it is optional to define them here, rather than in the module itself
 */

export const session = {
  key: 'session',
  baseUrl: hipNewUrl,
  url: '/api/common/get-session'
} as UseFetchOptions;
